import { getData, postData, putData } from "../../api";

// Blog
export const postBespokeStep1 = async (data) => {
    try {
        return await postData(`/luxury/bespoke-gift/step-1`, data);
    } catch (error) {
        console.log(error);
    }
};
export const postBespokeStep2 = async (id, data) => {
    try {
        return await postData(`/luxury/bespoke-gift/step-2/${id}`, data);
    } catch (error) {
        console.log(error);
    }
};
export const postBespokeStep3 = async (id, data) => {
    try {
        return await postData(`/luxury/bespoke-gift/step-3/${id}`, data);
    } catch (error) {
        console.log(error);
    }
};
export const postBespokeStep4 = async (id, data) => {
    try {
        return await postData(`/luxury/bespoke-gift/step-4/${id}`, data);
    } catch (error) {
        console.log(error);
    }
};
export const getBespokeProgress = async (id) => {
    try {
        return await getData(`/luxury/bespoke-gift/get-progress/${id}`);
    } catch (error) {
        console.log(error);
    }
};